import * as React from 'react';
const reactRouter = require('react-router');
const Route = reactRouter.Route;
const IndexRoute = reactRouter.IndexRoute;
const Redirect = reactRouter.Redirect;

import App from './components/App';

import WelcomePage from './components/WelcomePage';
import LoginPage from './components/LoginPage';
import FindOwnersPage from './components/owners/FindOwnersPage';
import OwnersPage from './components/owners/OwnersPage';
import NewOwnerPage from './components/owners/NewOwnerPage';
import EditOwnerPage from './components/owners/EditOwnerPage';
import NewPetPage from './components/pets/NewPetPage';
import EditPetPage from './components/pets/EditPetPage';
import VisitsPage from './components/visits/VisitsPage';
import VetsPage from './components/vets/VetsPage';
import ErrorPage from './components/ErrorPage';
import NotFoundPage from './components/NotFoundPage';

// Debug: Check if all components are defined
if (!Route) console.error('Route is undefined');
if (!App) console.error('App is undefined');
if (!WelcomePage) console.error('WelcomePage is undefined');
if (!LoginPage) console.error('LoginPage is undefined');
if (!FindOwnersPage) console.error('FindOwnersPage is undefined');
if (!OwnersPage) console.error('OwnersPage is undefined');
if (!NewOwnerPage) console.error('NewOwnerPage is undefined');
if (!EditOwnerPage) console.error('EditOwnerPage is undefined');
if (!NewPetPage) console.error('NewPetPage is undefined');
if (!EditPetPage) console.error('EditPetPage is undefined');
if (!VisitsPage) console.error('VisitsPage is undefined');
if (!VetsPage) console.error('VetsPage is undefined');
if (!ErrorPage) console.error('ErrorPage is undefined');
if (!NotFoundPage) console.error('NotFoundPage is undefined');

export default () => {
  if (!Route) {
    return <div style={{padding: '20px', color: 'red'}}>
      <h2>Configuration Error</h2>
      <p>Route component is undefined. Check react-router import.</p>
    </div>;
  }
  
  return (
    <Route component={App}>
      <Route path='/' component={WelcomePage} />
      <Route path='/login' component={LoginPage} />
      <Route path='/owners/list' component={FindOwnersPage} />
      <Route path='/owners/new' component={NewOwnerPage} />
      <Route path='/owners/:ownerId/edit' component={EditOwnerPage} />
      <Route path='/owners/:ownerId/pets/:petId/edit' component={EditPetPage} />
      <Route path='/owners/:ownerId/pets/new' component={NewPetPage} />
      <Route path='/owners/:ownerId/pets/:petId/visits/new' component={VisitsPage} />
      <Route path='/owners/:ownerId' component={OwnersPage} />
      <Route path='/vets' component={VetsPage} />
      <Route path='/error' component={ErrorPage} />
      <Route path='*' component={NotFoundPage} />
    </Route>
  );
};

